import { LeftAlignIcon, TopAlignIcon } from 'canoe';
import React, { useCallback } from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  alignItems?: string;
  alignSelf?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
  isChild?: boolean;
}

export const AlignFlexStart = ({
  alignItems,
  alignSelf,
  flexDirection,
  toggleValues,
  isChild,
}: Props) => {
  const onClick = useCallback(() => {
    if (isChild) {
      toggleValues({
        alignSelf: 'flex-start',
      });
    } else {
      toggleValues({
        alignItems: 'flex-start',
      });
    }
  }, [isChild, toggleValues]);

  return (
    <ValueToggle
      toggleGroup={isChild ? 'self-align' : 'flex-align-items'}
      id={isChild ? 'self-align-flex-start' : 'align-flex-start'}
      data-cy="toolbox-flex-align-start"
      onClick={onClick}
      isActive={isChild ? alignSelf === 'flex-start' : alignItems === 'flex-start'}
      icon={flexDirection === 'row' ? TopAlignIcon : LeftAlignIcon}
      tooltip="Start"
      color="light"
    />
  );
};
